// ─────────────────────────────────────────────────────────────────────────────
// Geopolitical alignment — single source of truth for the Friendly / Unfriendly
// classification (per Russian government designation, Order 83-r, 2022 — factual,
// not editorial). Shared by Market Insights (single-year snapshot) and Growth
// Analysis (year-over-year trend) so the labels, colours, and regions never drift.
// ─────────────────────────────────────────────────────────────────────────────

export const ALIGN_COLOR = { friendly: "#22c55e", unfriendly: "#C1121F", unknown: "#818084" };
export const ALIGN_BG    = { friendly: "#dcfce7", unfriendly: "#fdecec", unknown: "#F4F4F5" };
export const ALIGN_LABEL = { friendly: "Friendly", unfriendly: "Unfriendly", unknown: "Unknown" };

export const REGIONS = ["Asia", "Middle East & Oceania", "Europe", "Africa", "Americas"];

// Abbreviate long region labels for narrow chart axes.
export const REGION_SHORT = { "Middle East & Oceania": "ME & Oceania" };

// Attribution line shown wherever alignment is displayed.
export const ALIGN_SOURCE_NOTE =
  "Alignment per Russian government designation (Order 83-r, 2022) — factual classification, not editorial.";

// Subtle single-hue background tint conveying count intensity without strong
// colour. ratio 0 → nearly transparent, ratio 1 → light brand tint (max ~0.34
// alpha) so dense cells read darker while the table stays scannable.
export function intensityBg(count, max) {
  if (!count || max <= 0) return "transparent";
  const alpha = 0.06 + (count / max) * 0.28;
  return `rgba(232, 67, 26, ${alpha.toFixed(3)})`;
}

// Merge two years of /insights/geopolitical rows (each: { country, country_iso3,
// region, alignment_flag, exhibitor_count }) into one YoY row per country.
// Current-year metadata wins; falls back to previous year for dropped countries.
// Returns rows sorted by current-year count desc.
export function mergeGeoYoY(prevArr, currArr) {
  const m = {};
  (prevArr || []).forEach(r => {
    m[r.country] = {
      country: r.country, region: r.region, alignment_flag: r.alignment_flag,
      iso3: r.country_iso3, prev: r.exhibitor_count || 0, curr: 0,
    };
  });
  (currArr || []).forEach(r => {
    const e = m[r.country] || (m[r.country] = { country: r.country, prev: 0, curr: 0 });
    e.curr = r.exhibitor_count || 0;
    e.region = r.region;                 // current year is authoritative
    e.alignment_flag = r.alignment_flag;
    e.iso3 = r.country_iso3;
  });
  return Object.values(m)
    .map(x => ({ ...x, delta: x.curr - x.prev, g: x.prev > 0 ? Math.round(((x.curr - x.prev) / x.prev) * 100) : null }))
    .sort((a, b) => b.curr - a.curr);
}
